const NTT_PREFIX = '/Ntt-';

/**
 * Checks if the provided search data includes the 'visualNavigation' template and has a PLP banner.
 * @param {Object} searchData - The search data object to check.
 * @returns {boolean} Returns true if the conditions are met, otherwise false.
 */
export const isEtchVisNavOnPLP = (searchData) => {
  try {
    if (searchData === null || searchData === undefined || Object.keys(searchData).length === 0) {
      return false;
    }
    const stringifiedPartialTemplates = searchData?.searchModel?.partialTemplates;
    const etchVisualNavExists = (stringifiedPartialTemplates?.[0] || '').indexOf('visualNavigation') > -1;
    const hasPLPBanner = searchData?.searchModel?.metadata?.hasPLPBanner;
    const isPLPPage = searchData?.searchModel?.metadata?.contentType === 'plppage';
    return hasPLPBanner && etchVisualNavExists && isPLPPage;
  } catch (err) {
    // eslint-disable-next-line no-console
    return false;
  }
};
